// extracted by mini-css-extract-plugin
export default {"button":"S0b9aSnF"};